<div class="body" @show>

    <div class="header">

        <div class="headline">
            Mögliche Dubletten ({{doublets.length}} von {{total}})
        </div>

        <button mat-icon-button color="warn" (click)="service.setDoubletCheckerVisible(false)">
            <mat-icon>clear</mat-icon>
        </button>

    </div>

    <div class="content">

        <ng-container *ngIf="doublets.length > 0; else noDoubletsWrapper">

            <ng-container *ngFor="let doublet of doublets">

                <div class="doublet-wrapper" (click)="service.doubletClick(doublet)">
        
                    <div class="title">{{doublet.title}}</div>

                    <ng-container *ngIf="doublet.subTitles">

                        <div class="sub-title" *ngFor="let subTitle of doublet.subTitles">

                            <span class="attribute">{{subTitle.attribute}}</span>
                            <span class="value">{{subTitle.value}}</span>

                        </div>

                    </ng-container>
        
                </div>
        
            </ng-container>

        </ng-container>

    </div>

</div>

<ng-template #noDoubletsWrapper>

    <span class="no-doublets-hint">Keine Dubletten gefunden</span>

</ng-template>
